import {  Button, IconButton, TextField } from "@mui/material";
import { GridColDef, GridRowId } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";
import { NavigateFunction } from "react-router";
import ItemStatus from "../../../../../../common/components/item_status";



type Props = {
  onActionDeletar: (Id: number | null, openState: boolean) => void,
  OnActionQtdeEstoqueMinChange(quantidade: number | null, idLinhaGrid: GridRowId): void;
  OnActionQtdeEstoqueMaxChange(quantidade: number | null, idLinhaGrid: GridRowId): void;
  OnActionLocalArmazenamentoChange(local: string | null, idLinhaGrid: GridRowId): void;
};

export const GenerateControleEstoqueColumns = ({
  onActionDeletar,
  OnActionQtdeEstoqueMinChange,
  OnActionQtdeEstoqueMaxChange,
  OnActionLocalArmazenamentoChange,
}: Props): GridColDef[] => {

  //#region Status
  const computeItemStatusTitle = (status: string) => {
    switch (status) {
      case 'EI':
        return "EI"; 
      case 'EB':
        return "EB";
      case 'EA':
        return "EA";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: string) => {
    switch (status) {
      case 'EI':
        return "green";   // badge-success (Estoque Ideal)
      case 'EB':
        return "red";     // badge-danger (Estoque Baixo)
      case 'EA':
        return "yellow";  // badge-warning (Estoque Acima / Alto)
      default:
        return "gray";
    }
  };

  // Descrições (Tooltips) traduzidas do SQL
  const computeItemStatusDescription = (status: string) => {
    switch (status) {
      case 'EI':
        return "Estoque Ideal";
      case 'EB':
        return "Estoque Baixo";
      case 'EA':
        return "Estoque Acima do Máximo";
      default:
        return "Status não definido";
    }
  };
  //#endregion

  return [
    {
      field: "LabelStatus",
      filterable: false,
      headerName: "Status",
      flex: 1,
      maxWidth: 80,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)} 
          />
        </div>
      )
    },
    {
      field: "NomeProdutoServico",
      filterable: false,
      headerName: "Produto",
      flex: 1,
      minWidth: 100,
      sortable: false,
    },
    {
      field: "Unidade",
      filterable: false,
      headerName: "Unidade",
      width: 80,
      sortable: false,
    },
    {
      field: "QtdeEstoque",
      filterable: false,
      headerName: "Qtde Em Estoque",
      minWidth: 126,
      sortable: false,
    },
    {
      field: "QtdeEstoqueMin",
      filterable: false,
      width: 120,
      headerName: "Estoque Mínimo",
      sortable: false,
      renderCell: (params) => {
          const { row, id } = params;
          return (
              <div className="w-full flex items-center justify-center h-full p-1">
                  <TextField
                      size="small"
                      fullWidth
                      type="number"
                      variant="outlined"
                      value={row.QtdeEstoqueMin ?? ''}
                      onChange={(e) => {
                          const valor = e.target.value ? Number(e.target.value) : null;
                          OnActionQtdeEstoqueMinChange(valor, id);
                      }}
                  />
              </div>
          );
        },
    },
    {
      field: "QtdeEstoqueMax",
      filterable: false,
      width: 120,
      headerName: "Estoque Máximo", 
      sortable: false,
      renderCell: (params) => {
          const { row, id } = params;
          return (
              <div className="w-full flex items-center justify-center h-full p-1">
                  <TextField
                      size="small"
                      fullWidth
                      type="number"
                      variant="outlined"
                      value={row.QtdeEstoqueMax ?? ''}
                      onChange={(e) => {
                          const valor = e.target.value ? Number(e.target.value) : null;
                          OnActionQtdeEstoqueMaxChange(valor, id);
                      }}
                  />
              </div>
          );
        },
    },
    {
      field: "LocalArmazenamento",
      filterable: false,
      minWidth: 180,
      headerName: "Local Armazenamento", // Título ajustado
      sortable: false,
      renderCell: (params) => {
          const { row, id } = params;
          return (
              <div className="w-full flex items-center justify-center h-full p-1">
                  <TextField
                      size="small"
                      fullWidth
                      type="text"
                      variant="outlined"
                      value={row.LocalArmazenamento ?? ''}
                      onChange={(e) => {
                          const valor = e.target.value ? e.target.value : null;
                          OnActionLocalArmazenamentoChange(valor, id);
                      }}
                  />
              </div>
          );
        },
    },
    {
    field: 'IdItemControleEstoque',
    sortable: false,
    filterable: false,
    headerName: 'Ações',
    minWidth: 150,
    renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-1">
            <IconButton onClick={() => onActionDeletar(params.value, true)} >
              <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}